var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"overlay":"","img-src":_vm.adPic,"img-alt":"主题图片","text-variant":"white","title":_vm.adTitle,"sub-title":"","sub-title-text-variant":"white-50","img-height":"400px"}})}
var staticRenderFns = []

export { render, staticRenderFns }